import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import EmailPreferences from "@/components/EmailPreferences";

export default function EmailPreferencesPage() {
  const [params] = useSearchParams();
  const u = params.get("u") || "";
  const t = params.get("t") || "";
  const k = params.get("k") || "";
  const path = `/email/preferences/${encodeURIComponent(u)}/${encodeURIComponent(t)}`;
  const [kindLabel, setKindLabel] = React.useState("");

  const load = () => api.get(`${path}?k=${encodeURIComponent(k)}`).then(({ data }) => { setKindLabel(data.kind_label || ""); return data; });
  const save = (body) => api.put(path, { ...body, kind: k }).then(({ data }) => data);

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 sm:py-16" data-testid="email-preferences-page">
      <div className="tracking-overline mb-2">Email preferences</div>
      <h1 className="font-serif text-3xl sm:text-4xl text-[#11211A] mb-2">Choose what we send you</h1>
      <p className="text-sm text-[#7D8C85] mb-8">Tick only the reminders you find useful, or stop everything with one click. Changes apply immediately.</p>
      {!u || !t ? (
        <div className="text-sm text-[#B35C4A]" data-testid="email-prefs-missing-link">This page needs the link from one of our emails. <Link to="/login" className="underline">Sign in</Link> to manage preferences from your dashboard instead.</div>
      ) : (
        <EmailPreferences load={load} save={save} kindLabel={kindLabel} />
      )}
      <div className="mt-8 text-xs text-[#7D8C85]">Supplier with an account? Preferences are also under <Link to="/dashboard?tab=email-prefs" className="underline">Dashboard → Email preferences</Link>.</div>
    </div>
  );
}
